import React from 'react'
import Button, { TYPES } from '../Button/index'

const Experience = ({
  title, cost, buttonText, description, handleClick,
  disabled, url, query, backgroundColor, target,
}) => {
  const button = (
    buttonText
      && <Button
        type={TYPES.PRIMARY}
        className="live-events__experience__button"
        disabled={disabled}
        url={!disabled ? url : undefined}
        query={!disabled ? query : undefined}
        target={target}
        onClick={handleClick}
      >
        {buttonText}
      </Button>
  )

  return (
    <div className="live-events__experience__background">
      <div
        className="live-events__experience"
        style={{
          backgroundColor,
        }}
      >
        <div className="title-cost-button">
          <div className="live-events__experience-title">
            {title}
          </div>
          <div className="live-events__experience-cost">
            {cost}
          </div>
          {button}
        </div>
        <div
          className="description"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
    </div>
  )
}

export default Experience
